export const TOKEN = 'token';
export const REFRESH_TOKEN = 'refreshToken';
export const MSAL_TOKEN = 'msal';
export const GUID_NULL = '00000000-0000-0000-0000-000000000000';
